import "./DaPasswordSaved.css";
import Button from "@mui/material/Button";
import { useLocation } from "react-router-dom";
import DaPageWrapper from "../DaPageWrapper/DaPageWrapper";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { translateStatic } from "../../hooks/useT/useT";

const DaPasswordSaved = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const redirectUrl = queryParams.get("redirectUrl");
  const email = queryParams.get("email");
  const lang = queryParams.get("lang");

  const signInUrl = (() => {
    if (!redirectUrl) return "";

    try {
      const finalUrl = new URL(redirectUrl);

      if (email) finalUrl.searchParams.set("email", email);
      if (lang) finalUrl.searchParams.set("language", lang);

      return finalUrl.toString();
    } catch {
      return "";
    }
  })();

  return (
    <DaPageWrapper
      wrapperClass={"da-passwordsaved-card da-page-wrapper"}
      iconType="lock"
      title={<Translate tKey={T_KEYS.DA.SAVED.TITLE} />}
      subtitle={<Translate tKey={T_KEYS.DA.SAVED.DESCRIPTION} />}
    >
      <Button
        variant="contained"
        fullWidth
        className="da-button da-passwordsaved-button"
        href={signInUrl || undefined}
        target="_self"
        disabled={!signInUrl}
      >
        {translateStatic(T_KEYS.DA.BUTTON.SIGNIN)}
      </Button>
    </DaPageWrapper>
  );
};

export { DaPasswordSaved };
